module.exports = __webpack_public_path__ + "static/media/icon_invalid.1af6d38a.svg";